export default "__VITE_ASSET__C7_bG1ZU__"